import { memo } from 'react';

import SvgIcon from './lib/SvgIcon';

type Props = React.ComponentProps<typeof SvgIcon> & {
  fill?: string;
};

const HamburgerIcon = (props: Props) => {
  const { fill, ...restProps } = props;

  return (
    <SvgIcon {...restProps}>
      <path d="M3 6h18v2H3V6m0 5h18v2H3v-2m0 5h18v2H3v-2z" fill={fill} />
    </SvgIcon>
  );
};

HamburgerIcon.normalized = true;

export default memo(HamburgerIcon);
